import { removePunctuation } from "../../Utilities/UtilityMethods";
import { TranscriptViewModel } from "./TranscriptViewModel";

export default class TranscriptTextFinder {
    searchText: string = "";
    matchCount: number = 0;
    messages: TranscriptTextFinderMessage[] = [];

    constructor(searchText: string, transcript: TranscriptViewModel) {
        this.searchText = searchText;

        let setsOfWordsToMatch: string[][] = [];

        const words = searchText
            .split(' ');

        let wordsToMatch: string[] = [];

        for (let i = 0; i < words.length; i++) {
            if (words[i][words[i].length - 1] === ',') {
                wordsToMatch.push(removePunctuation(words[i]).trim().toLowerCase());
                setsOfWordsToMatch.push(wordsToMatch);
                wordsToMatch = [];
            }
            else {
                wordsToMatch.push(removePunctuation(words[i]).trim().toLowerCase());
            }
        }

        if (wordsToMatch.length > 0) {
            setsOfWordsToMatch.push(wordsToMatch);
        }

        this.findMatches(setsOfWordsToMatch, transcript);
    }

    findMatches = (setsOfWordsToMatch: string[][], transcript: TranscriptViewModel) => {
        const messages = transcript.messages;

        for (let messageIndex = 0; messageIndex < messages.length; messageIndex++) {
            const lines = messages[messageIndex].lines;

            for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
                const line = lines[lineIndex];
                const formattedLineText = line.words
                    .map(x => removePunctuation(x.content.trim().toLowerCase()));

                var allMatchingSetsOfIndices: number[][] = [];
                var currentMatchingSetsOfIndices: number[] = [];

                for (let wordSetIndex = 0; wordSetIndex < setsOfWordsToMatch.length; wordSetIndex++) {
                    let wordSet = setsOfWordsToMatch[wordSetIndex];
                    var wordIndex = 0;
                    for (let i: number = 0; i < formattedLineText.length; i++) {
                        if (formattedLineText[i].includes(wordSet[wordIndex])) {
                            currentMatchingSetsOfIndices.push(i);
                            wordIndex++;
                            // if match is already found, resets to find another match on same line
                            if (currentMatchingSetsOfIndices.length === wordSet.length) {
                                allMatchingSetsOfIndices.push(currentMatchingSetsOfIndices);
                                currentMatchingSetsOfIndices = [];
                                wordIndex = 0;
                            }
                        }
                        else {
                            currentMatchingSetsOfIndices = [];
                            wordIndex = 0;
                        }
                    }
                }

                if (allMatchingSetsOfIndices.length > 0) {
                    let message = this.messages.find(message => message.index === messageIndex);
                    let line = new TranscriptTextFinderLine();
                    line.messageIndex = messageIndex;
                    line.lineIndex = lineIndex;

                    let newMessage = new TranscriptTextFinderMessage();
                    newMessage.index = messageIndex;

                    line.matchingSetsOfIndices = allMatchingSetsOfIndices;

                    if (!message) {
                        newMessage.lines.push(line);
                        this.messages.push(newMessage);
                    }
                    else {
                        message.lines.push(line);
                    }

                    this.matchCount += allMatchingSetsOfIndices.length;
                }
            }
        }
    }
}

export class TranscriptTextFinderMessage {
    index: number;
    lines: TranscriptTextFinderLine[] = [];
}

export class TranscriptTextFinderLine {
    messageIndex: number;
    lineIndex: number;
    matchingSetsOfIndices: number[][] = [];
}
